import React from 'react';
import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import useStyles from './learning-plan-breadcrumbs.style';

/**
 * Reusable breadcrumb component for learning plans module
 * 
 * @param {Object} props
 * @param {Array} props.items - Array of breadcrumb items
 * @param {string} props.items[].label - Display label for the breadcrumb item
 * @param {Function} props.items[].onClick - Click handler (optional, if not provided, item is non-clickable)
 * @param {boolean} props.items[].isCurrent - Whether this is the current page (non-clickable)
 */
const LearningPlanBreadcrumbs = ({ items = [] }) => {
  const classes = useStyles();

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      className={classes.breadcrumbs}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isClickable = item.onClick && !item.isCurrent && !isLast;

        if (isClickable) {
          return (
            <Link
              key={item.label}
              component="button"
              variant="body1"
              onClick={item.onClick}
              className={classes.breadcrumbLink}
            >
              {item.label}
            </Link>
          );
        }

        return (
          <Typography
            key={item.label}
            variant="body1"
            className={classes.breadcrumbCurrent}
          >
            {item.label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

export default LearningPlanBreadcrumbs;

